









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CapacitesSite extends Vue {
    @Prop() content!: string
}
